export enum CertificationTypes {
    ATTRIBUTE_CERT = 'ATTRIBUTE_CERT',
    TOOLCHAIN_CERT = 'TOOLCHAIN_CERT',
    PTG_CERT = 'PTG_CERT',
    ATTRIBUTE_MANDATORY_CERT = 'ATTRIBUTE_MANDATORY_CERT',
    PARTNER_CERT = 'PARTNER_CERT',
    ONTOLOGY_CERT = 'ONTOLOGY_CERT'
}
